import { Price } from 'src/types';

const defaults: Readonly<Price> = {
  amount: 0,
  currency: 'GBP',
};

export const priceBuilder = (price?: Partial<Price>): Readonly<Price> => ({
  ...defaults,
  ...price,
});
